import React from 'react';
import { EnvelopeIcon, TrashIcon } from '@heroicons/react/24/outline';
import moment from 'moment';
import CustomTooltipComponent from './custom_tooltip_component';



export default function ComunicationsList({
    messages,
    showDetails,
    handleShowDetails,
    handleDeleteAlert,
    handleToggleReadBy,
    readByVisible,
    selectedAlertId,
    readByData,
    loadingReadBy,
    errorLoadingReadby,
    currentPageReadby,
    totalPagesReadby,
    handlePreviousPageReadby,
    handleNextPageReadby,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage
}) {
    return (
        <>
            <ul role="list">
                {messages.map((message) => (
                    <li key={message.id}>
                    <div className="relative pb-4">
                        <div className="relative flex space-x-3 cursor-pointer hover:bg-indigo-50" onClick={() => handleShowDetails(message.id)}>
                        <div>
                            <span className="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-indigo-600">
                            <EnvelopeIcon className='h-5 w-5 text-white' />
                            </span>
                        </div>
                        <div className="flex flex-col sm:flex-row min-w-0 w-full flex-1 justify-between space-y-2 sm:space-y-0 sm:space-x-4 pt-1.5">
                            <p className="text-sm text-gray-700 uppercase">
                                {message.title}{' '}
                            </p>
                            <div className="whitespace-normal text-right justify-end text-sm text-gray-500">
                                <time dateTime={message.created_at}>{new Date(message.created_at).toLocaleString()}</time>
                            </div>
                        </div>
                        <CustomTooltipComponent title="Elimina avviso" placement="top-start" arrow>
                            <div 
                                className='items-center flex hover:text-indigo-800 cursor-pointer' 
                                onClick={(e) => { 
                                    e.stopPropagation();
                                    handleDeleteAlert(message.id, message.title);
                                }}
                            >
                                <TrashIcon className='w-5 h-5 hover:text-red-500' />
                            </div>
                        </CustomTooltipComponent>
                        </div>
                        {showDetails[message.id] && (
                            <div className='container p-4 ml-8'>
                                <div className='pr-4'>
                                <span className="tracking-wider text-xs uppercase text-gray-600">Messaggio: </span>
                                <div className="text-sm text-gray-800 max-h-32 overflow-y-auto">
                                    <span className="block">
                                    {message.message.split('\n').map((line, index) => (
                                        <p key={index} className="break-words">
                                        {line}
                                        </p>
                                    ))}
                                    </span>
                                </div>
                                <hr className="bg-indigo-600 mt-2 pr-2 pr-4" style={{ height: '2px' }} />
                                <div className="text-sm text-gray-800 pr-2 py-2">
                                    <span className="tracking-wider text-xs uppercase text-gray-600">Inviato a: </span>
                                    
                                    {message.organizational_units && Array.isArray(message.organizational_units) && message.organizational_units.length > 0 ? (
                                    <ul className="grid grid-cols-2 list-disc ml-6">
                                        {message.organizational_units_details && Array.isArray(message.organizational_units_details) ? (
                                        message.organizational_units_details.map((organitazionalUnit) => (
                                            <li key={organitazionalUnit.id} className="flex items-center text-sm text-gray-800">
                                            <span className="block w-1.5 h-1.5 mr-2 bg-indigo-600 rounded-full"></span>
                                                Unità organizzativa: {organitazionalUnit.name}
                                            </li>
                                        ))
                                        ) : (
                                        <li key="no-employees" className="flex items-center text-sm text-gray-800">
                                            Nessuna unità organizzativa trovata
                                        </li>
                                        )}
                                    </ul>
                                    ) : message.send_to_all ? (
                                    'Tutti'
                                    ) : message.employees && Array.isArray(message.employees) && message.employees.length > 0 ? (
                                    <div className="max-h-32 overflow-y-auto">
                                        <ul className="grid grid-cols-2 list-disc ml-6">
                                        {message.employees_details && Array.isArray(message.employees_details) ? (
                                            message.employees_details
                                            .sort((a, b) => {
                                                return a.cf.localeCompare(b.cf);
                                            })
                                            .map((employee) => (
                                                <li key={employee.id} className="flex items-center text-xs text-gray-800">
                                                <span className="block w-1.5 h-1.5 mr-2 bg-indigo-600 rounded-full"></span>
                                                {employee.last_name && employee.first_name ? (
                                                    <>{employee.last_name} {employee.first_name}</>
                                                ) : (
                                                    <>{employee.cf}</>
                                                )}
                                                </li>
                                            ))
                                        ) : (
                                            <li key="no-employees" className="flex items-center text-xs text-gray-800">
                                            Nessun dipendente trovato
                                            </li>
                                        )}
                                        </ul>
                                    </div>
                                    ) : (
                                    'Nessuno'
                                    )}
                                </div>
                                <hr className="bg-indigo-500 mt-2 pr-2" style={{ height: '2px' }} />
                                </div>
                                <div className="text-sm text-gray-800 pt-2">
                                <div className="flex items-center space-x-2">
                                    <span className="tracking-wider text-xs uppercase text-gray-600 me-3">
                                    Letto da: {message?.read_by}
                                    </span>

                                    {Number(message?.read_by) > 0 && (
                                    <button
                                        className="border rounded-md px-2 py-1 text-center text-xs font-semibold text-white bg-indigo-600 shadow-sm hover:bg-indigo-500"
                                        onClick={() => handleToggleReadBy(message.id)}
                                    >
                                        {readByVisible && selectedAlertId == message.id ? 'Nascondi' : 'Visualizza'}
                                    </button>
                                    )}
                                </div>

                                {loadingReadBy &&  <p className='text-sm text-gray-500'>Caricamento...</p>}
                                {errorLoadingReadby && <p className="text-sm text-gray-600">⚠️ Errore nel recupero dei dati.</p>}
                                {!loadingReadBy && !errorLoadingReadby && readByVisible && selectedAlertId == message.id && (
                                    <div className="mt-4 me-4 border p-4 rounded-md shadow bg-white">
                                    <div className="flex justify-between items-center mb-2">
                                        <h3 className="text-sm font-semibold text-gray-800">Dipendenti</h3>
                                    </div>
                                    <ul className="text-sm text-gray-700 space-y-1 max-h-60 overflow-y-auto">
                                        {readByData.map(({ employee, read_at }, index) => (
                                        <li key={index} className="border-b pb-1">
                                            {employee.last_name} {employee.first_name} – <span className="text-gray-500 text-xs">{moment(read_at).format('DD/MM/YYYY')} - {moment(read_at).format('HH:mm:ss')}</span>
                                        </li>
                                        ))}
                                    </ul>

                                    {readByData.length > 0 && totalPagesReadby > 1 && (
                                        <div className="flex items-center justify-between mt-3">
                                        <button
                                            onClick={handlePreviousPageReadby}
                                            disabled={currentPageReadby === 1}
                                            className={`border rounded-md shadow-sm text-sm font-semibold text-center px-2 py-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                            currentPageReadby === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                                            }`}
                                        >
                                            Pagina precedente
                                        </button>

                                        <div className="text-sm font-semibold text-gray-800">
                                            Pagina {currentPageReadby} di {totalPagesReadby}
                                        </div>

                                        <button
                                            onClick={handleNextPageReadby}
                                            disabled={currentPageReadby === totalPagesReadby}
                                            className={`border rounded-md shadow-sm text-sm font-semibold text-center px-2 py-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                            currentPageReadby === totalPagesReadby ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                                            }`}
                                        >
                                            Pagina successiva
                                        </button>
                                        </div>
                                    )}

                                    </div>
                                )}
                                </div>
                            </div>
                        )}
                    </div>
                    </li>
                ))}
            </ul>
            {totalPages > 1 && (
                <div className="flex items-center justify-between mt-6">
                    <button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 ${
                            currentPage === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                        }`}
                    >
                        Pagina precedente
                    </button>

                    <div className="text-sm font-semibold text-gray-800">
                        Pagina {currentPage} di {totalPages}
                    </div>

                    <button
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                        className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 ${
                            currentPage === totalPages ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                        }`}
                    >
                        Pagina successiva
                    </button>
                </div>
            )}
        </>
    );
}
